/*
  Line illustrations (snippets/aw-illustration.liquid) are still drawings: they
  fade in once (assets/aw-motion.css) and never move. This file keeps them off
  the words around them.
*/
/*
  Keep drawings off the words. Section text changes from page to page (and in the
  theme editor), so fixed positions alone can't guarantee a drawing never touches
  a heading, paragraph or button. After layout, each drawing is checked stroke by
  stroke against the text lines, buttons and logos of its section:
  - touching → shrink it towards its anchored corner (down to 55%) until clear;
  - still touching (or a scattered drawing, data-aw-avoid, e.g. the stars) →
    hide just the pieces that touch.
  Runs regardless of motion settings; re-checked on resize and after fonts load.
*/
function keepClear(root) {
  const GAP = 8;
  const SCALES = [1, 0.88, 0.76, 0.65, 0.55];

  const visible = (el) => (el.checkVisibility ? el.checkVisibility() : el.getClientRects().length > 0);

  // Text line boxes (tight) plus buttons and logo images
  function blockersFor(section, illo) {
    const rects = [];
    const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!node.textContent.trim() || !parent || illo.contains(parent) || parent.closest('svg, script, style, .aw-illo')) continue;
      if (!visible(parent)) continue;
      const range = document.createRange();
      range.selectNodeContents(node);
      for (const r of range.getClientRects()) if (r.width > 1) rects.push(r);
    }
    section.querySelectorAll('.aw-btn, .button, button, img').forEach((el) => {
      if (illo.contains(el) || el.matches('.aw-fill, [class*="__art"]') || !visible(el)) return;
      // A drawing made to frame its own picture (the sparkles round the closing stamp)
      if (el.tagName === 'IMG' && el.parentElement === illo.parentElement) return;
      rects.push(el.getBoundingClientRect());
    });
    return rects;
  }

  // Screen points along every stroke (and text) inside a piece of the drawing
  function pointsOf(piece) {
    const points = [];
    const leaves = piece.matches('path, circle, ellipse, text') ? [piece] : piece.querySelectorAll('path, circle, ellipse, text');
    leaves.forEach((leaf) => {
      if (leaf.tagName === 'text') {
        const b = leaf.getBoundingClientRect();
        points.push([b.left, b.top], [b.right, b.bottom], [b.left, b.bottom], [b.right, b.top]);
        return;
      }
      const matrix = leaf.getScreenCTM();
      if (!matrix) return;
      const length = leaf.getTotalLength();
      const step = Math.max(3, length / 40);
      for (let at = 0; at <= length; at += step) {
        const p = leaf.getPointAtLength(at);
        points.push([matrix.a * p.x + matrix.c * p.y + matrix.e, matrix.b * p.x + matrix.d * p.y + matrix.f]);
      }
    });
    return points;
  }

  const touches = (points, rects) =>
    points.some(([x, y]) => rects.some((b) => x > b.left - GAP && x < b.right + GAP && y > b.top - GAP && y < b.bottom + GAP));

  // Top-level pieces; a single wrapping group is opened up one level
  function piecesOf(svg) {
    let pieces = [...svg.children];
    if (pieces.length === 1 && pieces[0].children.length > 1) pieces = [...pieces[0].children];
    return pieces;
  }

  (root || document).querySelectorAll('[data-aw-illo]').forEach((illo) => {
    const svg = illo.querySelector('svg');
    const section = illo.closest('.shopify-section') || illo.parentElement;
    illo.style.transform = '';
    illo.querySelectorAll('.aw-illo__skip').forEach((el) => el.classList.remove('aw-illo__skip'));
    if (!svg || !section || !visible(illo)) return;

    const rects = blockersFor(section, illo);
    if (!rects.length) return;

    if (!illo.hasAttribute('data-aw-avoid')) {
      // Shrink towards the side the drawing is pinned to
      const cs = getComputedStyle(illo);
      const x = cs.left === 'auto' && cs.right !== 'auto' ? 'right' : cs.right === 'auto' && cs.left !== 'auto' ? 'left' : 'center';
      const y = cs.bottom === 'auto' && cs.top !== 'auto' ? 'top' : 'bottom';
      illo.style.transformOrigin = `${x} ${y}`;
      for (const scale of SCALES) {
        illo.style.transform = scale === 1 ? '' : `scale(${scale})`;
        if (!touches(pointsOf(svg), rects)) return;
      }
    }

    piecesOf(svg).forEach((piece) => {
      if (touches(pointsOf(piece), rects)) piece.classList.add('aw-illo__skip');
    });
  });
}

(function () {
  let timer;
  const run = () => keepClear(document);
  run();
  window.addEventListener('load', run);
  if (document.fonts) document.fonts.ready.then(run);
  const later = () => {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  };
  window.addEventListener('resize', later);
  // Scroll reveals move text into its final place (assets/aw-motion.js)
  document.addEventListener('aw:revealed', later);
  // Theme editor: sections are re-rendered when settings change.
  document.addEventListener('shopify:section:load', (event) => keepClear(event.target));
})();
